import { AppConstants } from "../../../app.constants";
import { Machine } from "./machine.type";

export class MachineCategory {
  Id: number;
  Description: string;
  Machines: Machine[];

  constructor(
    public Name: string = '',
    public Color: string = AppConstants.MACHINE_CATEGORY_DEFAULT_BACKGROUND_COLOR
  ) {}
}
